import React from "react";
import { columns } from "./columns.js";
import StoreIcon from "@material-ui/icons/Store";
import CardTable from "components/CardTable/CardTable.jsx";
import RegularButton from "components/CustomButtons/Button.js";
import AddIcon from "@material-ui/icons/Add";
import { useToggle } from "hooks/useToggle.js";
import { ModalV2 } from "components/Modal/ModalV2.jsx";
import { useDispatch, useSelector } from "react-redux";
import Snackbar from "components/Snackbar/Snackbar.js";
import { clearSnackbar } from "redux/actions/search/searchActions.js";
import { NewFormCondition } from "./NewFormCondition.jsx";

export const ConditionsView = () => {
  const dispatch = useDispatch();
  const [open, handleOpen] = useToggle();
  const { conditions } = useSelector(
    ({ conditionsReducer }) => conditionsReducer
  );
  const { isLoading, color, message, isOpen } = useSelector(
    ({ search }) => search
  );

  const handleClose = () => {
    dispatch(clearSnackbar());
  };

  return (
    <>
      <CardTable
        columns={columns}
        data={conditions}
        isLoading={isLoading}
        hasControl
        hasHeader
        icon={<StoreIcon />}
        title="Condiciones de Comercio"
        titleBlock
        blockBtn
        hasControls
        controls={
          <RegularButton
            color="info"
            size="sm"
            tooltip="Agregar nueva condición"
            justIcon
            round
            onClick={handleOpen}
          >
            <AddIcon />
          </RegularButton>
        }
      />
      <ModalV2
        open={open}
        onClose={handleOpen}
        title="Agregar nueva condición"
        toRight
      >
        <NewFormCondition close={handleOpen} />
      </ModalV2>
      <Snackbar
        place="tr"
        close
        color={color}
        open={isOpen}
        message={message}
        closeNotification={handleClose}
      />
    </>
  );
};
